import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "./index.js";
import styled, { keyframes } from "styled-components";
import { FaSpinner } from "react-icons/fa";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 0 16px;
`;

const Texto = styled.h1`
  margin-left: 8px;
  font-size: 14px;
  color: #333;
`;

const SpinnerIcon = styled(FaSpinner)`
  animation: ${spin} 1s linear infinite;
  color: #333;
`;

const MIN_VISIBLE_TIME = 400;

const Loading = () => {
  const { loading } = useContext(AppContext);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("Carregando...");

  useEffect(() => {
    let timer;
    if (loading?.active) {
      setMessage(loading.message || "Carregando...");
      setVisible(true);
    } else {
      timer = setTimeout(() => setVisible(false), MIN_VISIBLE_TIME);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [loading]);

  if (!visible) return null;

  return (
    <LoadingOverlay>
      <SpinnerIcon />
      <Texto>{message}</Texto>
    </LoadingOverlay>
  );
};

export default Loading;
